import posthog from 'posthog-js'

interface CalculatorUsedProps {
  calculator: string
  result_gbp: number
  tier?: string
}

export function useAnalytics() {
  function trackCalculatorUsed(props: CalculatorUsedProps) {
    if (import.meta.env.PROD) {
      posthog.capture('calculator_used', props)
    }
  }

  return { trackCalculatorUsed }
}
